import React from 'react';
import './Row.css';
import Fighter from '../Fighter/Fighter';

class Row extends React.Component {

  render() {
    return (
      <div className="row" style={this.props.style}>
        {
          this.props.fighters.map(fighter => {
            return <Fighter key={fighter.id} name={fighter.name} image={fighter.image}
              counterRow={this.props.counterRow} counterRating={fighter.matchups[this.props.opponent.keyName]}
              playMetric={fighter.playMetric} maxMetric={this.props.maxMetric}/>
          })
        }
      </div>
    )
  }
}

export default Row;



// WEBPACK FOOTER //
// ./src/Components/Row/Row.js